// Lucide icon: zoom-out (https://lucide.dev/icons/zoom-out)
import { ZoomOut } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconZoomOut = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ZoomOut />
    </IconComponentStyled>
  )
}
